import { render, staticRenderFns } from "./Table7.vue?vue&type=template&id=23a5b38a&scoped=true&"
import script from "./Table7.vue?vue&type=script&lang=js&"
export * from "./Table7.vue?vue&type=script&lang=js&"
import style0 from "./Table7.vue?vue&type=style&index=0&id=23a5b38a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23a5b38a",
  null
  
)

export default component.exports